import type { ReactElement } from 'react';
import { Route, FeatureFlag } from 'config';
import useCurrentUser from 'hooks/useCurrentUser';

import Link from './Link';

function Sidebar(): ReactElement {
  const { currentUser } = useCurrentUser();

  return (
    <nav
      className="c-nav-account-sidebar"
      aria-label="Account navigation"
      data-fragment="sidenav-account-desktop"
    >
      <ul>
        <li>
          <span className="c-nav-account-sidebar__title">
            My Dashboard
          </span>
        </li>

        <Link
          href={Route.UPCOMING_MENUS}
          data-cy="sidebar-upcoming-deliveries"
        >
          Upcoming Deliveries
        </Link>
        <Link
          href={Route.DELIVERY_ADDRESS}
          data-cy="sidebar-delivery-address"
        >
          Delivery Address
        </Link>

        <Link
          href={Route.ORDER_HISTORY}
          data-cy="sidebar-order-history"
        >
          Order History
        </Link>

        <Link
          href="/tracking"
          data-cy="sidebar-track-package"
        >
          Track Package
        </Link>

        {currentUser.hasFeatureEnabled(FeatureFlag.FRIENDBUY) && (
          <Link
            href={Route.REFER}
            data-cy="sidebar-refer"
          >
            Refer & Earn
          </Link>
        )}

        <li className="c-nav-account-sidebar__divider" />

        <li>
          <span className="c-nav-account-sidebar__title">
            Help
          </span>
        </li>

        <Link
          href="https://purplecarrot.zendesk.com/hc/en-us"
          data-cy="sidebar-faqs"
          reload
        >
          <abbr>
            FAQs
          </abbr>
        </Link>

        <Link
          href="/contacts/new"
          data-cy="sidebar-contact-us"
          reload
        >
          Contact Us
        </Link>
      </ul>
    </nav>
  );
}

export default Sidebar;
